import { useState } from 'react';

import { Loader } from '@crehana/compass.ui/loader';

type PdfViewerProps = {
  pdfUrl: string;
  onLoad?: () => void;
  onError?: () => void;
};

export function PdfViewer({ pdfUrl, onLoad, onError }: PdfViewerProps) {
  const [status, setStatus] = useState<'loading' | 'loaded' | 'error'>(
    'loading',
  );

  const handleLoad = () => {
    setStatus('loaded');
    onLoad?.();
  };

  const handleError = () => {
    setStatus('error');
    onError?.();
  };

  if (status === 'error') {
    return null;
  }

  return (
    <div className="tw-relative tw-w-full tw-min-h-[24rem] tw-max-h-[56rem] tw-cds-radius-s tw-overflow-hidden tw-bg-neutral-light-200">
      {status === 'loading' && (
        <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-cds-bg-layer-02">
          <Loader />
        </div>
      )}
      <iframe
        src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(
          pdfUrl,
        )}`}
        title="PDF recibo"
        className="tw-w-full tw-min-h-[24rem] tw-border-0"
        onLoad={handleLoad}
        onError={handleError}
        height={560}
      />
    </div>
  );
}
